import { reducerWithInitialState } from "typescript-fsa-reducers";
import roomActions from "redux/actions/room";
import RoomRes from "types/res/room/RoomRes";

export type RoomState = RoomRes[];

const initialState = [] as RoomState;

const roomReducer = reducerWithInitialState(initialState)
  .case(roomActions.addRoomAction.done, (state, payload) => {
    return [...state, payload.result];
  })
  .case(roomActions.updateRoomAction.done, (state, payload) => {
    return state.map((item) =>
      item.roomId === payload.params.roomId ? payload.result : item
    );
  })
  .case(roomActions.deleteRoomAction.done, (state, payload) => {
    return state.filter((item) => item.roomId !== payload.params.roomId);
  })
  .case(roomActions.fetchRoomAction.done, (state, payload) => {
    return [...payload.result];
  });

export default roomReducer;
